export default __webpack_public_path__ + "static/media/Honored Hauberk of Passing Spirits.ce2d72fe.jpg";